function revealOnScroll() {
    const controller = new ScrollMagic.Controller();
    const revealElements = document.querySelectorAll('.reveal');

    for (const element of revealElements) {
        const scene = new ScrollMagic.Scene({
            triggerElement: element,
            triggerHook: 'onEnter',
            offset: 100
        }).on('start', function (event) {
            let currentItem = event.target.triggerElement();

            gsap.to(currentItem, 1.2, {
                autoAlpha: 1,
                y: 0,
                scale: 1,
                backgroundSize: 'auto 105%',
                transformOrigin: 'top',
                ease: 'power5.out'
            })
        })
            .reverse(false)
            .addTo(controller);
    }
}

function scrollingText() {
    const controller = new ScrollMagic.Controller();

    const scene = new ScrollMagic.Scene({
        triggerElement: '.services-list li',
        triggerHook: 'onEnter',
        offset: 150,
        duration: 2500
    }).setTween('.scrolling-text [data-scrolling-text]', {
        x: '-10vw',
        ease: 'none'
    }).addTo(controller);
}

/*
function revealPosts() {
    const controller = new ScrollMagic.Controller();

    const scene = new ScrollMagic.Scene({
        triggerElement: '.slider-posts-preview',
        triggerHook: 'onEnter',
        offset: 150,
        duration: 2500
    }).on('start', function () {

        gsap.to('.slider-posts-preview__slide', .7, {
            autoAlpha: 1,
            scale: 1,
            stagger: {
                from: "left",
                amount: .3
            }
        });
    })
        .reverse(false)
        .addTo(controller);
}
*/

function moveCardsOnScroll() {
    const cardInit = function() {
        let controller = new ScrollMagic.Controller();

        let myTween = gsap.to('.cards-list > div:nth-child(3n) .card,' +
            '.cards-list > div:nth-child(3n + 1) .card', {
            y: '-70%',
            marginTop: '10%',
            ease: 'none',
        });

        const cardTween = new ScrollMagic.Scene({
            triggerElement: '.cards-list',
            triggerHook: 'onEnter',
            offset: 150,
            duration: 2500
        }).setTween(myTween).addTo(controller);

        if (window.innerWidth > 992) {
            cardTween.enabled(true);
        } else {
            cardTween.enabled(false);
        }
    }

    document.addEventListener("DOMContentLoaded", function() {
        cardInit();
    });
}

function moveValuesOnScroll() {
    const controller = new ScrollMagic.Controller();

    const scene = new ScrollMagic.Scene({
        triggerElement: '.values-wrapper',
        triggerHook: 'onEnter',
        offset: -250,
        duration: 2500
    }).setTween('.values-list > div', {
        x: '-50%',
        ease: 'none',
    }).addTo(controller);
}

function headerOnScroll() {
    const controller = new ScrollMagic.Controller();

    const scene = new ScrollMagic.Scene({
        triggerElement: 'main',
        triggerHook: 0.1,
        offset: 150,
    })
        .setClassToggle('header', 'top-navigation--scrolling')
        .addTo(controller);
}

export {revealOnScroll, scrollingText, moveCardsOnScroll, moveValuesOnScroll, headerOnScroll};
